import { LOCALE_IT } from '~/constants/localization/locales';

export function useRequest() {
  function getRequestInfo(
    path: string,
    query?
  ) {
    const { $i18n } = useNuxtApp();
    const config = useRuntimeConfig();
    const baseUrl = $i18n.locale.value === LOCALE_IT ? config.public.baseDomainIt : config.public.baseDomainFr;

    let url = new URL('http://'+baseUrl+path);

    if (import.meta.client) {
      url = new URL('https://'+baseUrl+path);
    }

    const headers = {
      'x-forwarded-port': '443',
      'x-forwarded-proto': 'https',
      ...useRequestHeaders(['cookie']),
    }

    const retry = 0;

    if (query) {
      Object.keys(query).forEach((key) => {
        url.searchParams.append(key, query[key]);
      })
    }

    return {
      url,
      headers,
      retry
    }
  }

  return {
    getRequestInfo
  }
}
